<template>
  <b-row style="margin-top: 1em">
    <b-col cols="12" md="6">
      <b-card bg-variant="light" style="min-height: 140px" class="m-1">
        <b-row>
          <b-col>
            <h6 style="margin-top: 4px" class="text-info">
              {{ $t("globals.agent") }}:
            </h6>
          </b-col>
          <b-col>
            <b-form-input
              :placeholder="service.agent.full_name"
              size="sm"
              disabled
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 style="margin-top: 4px" class="text-info">
              {{ $t("globals.status") }}:
            </h6>
          </b-col>
          <b-col>
            <b-form-input :placeholder="service.status" size="sm" disabled />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 style="margin-top: 4px" class="text-info">
              {{ $t("globals.type") }}:
            </h6>
          </b-col>
          <b-col>
            <b-form-input
              :placeholder="service.service_type"
              size="sm"
              disabled
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 style="margin-top: 4px" class="text-info">
              {{ $t("globals.created_at") }}:
            </h6>
          </b-col>
          <b-col>
            <div v-b-tooltip.hover :title="service.created_at">
              <b-form-input
                :placeholder="service.created_at.substring(0, 10)"
                size="sm"
                disabled
              />
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col cols="12" md="6">
      <b-card bg-variant="light" style="min-height: 140px" class="m-1">
        <b-row>
          <b-col>
            <h6 style="margin-top: 4px" class="text-info">
              {{ $t("globals.assembly") }}:
            </h6>
          </b-col>
          <b-col>
            <b-input-group>
              <b-form-input
                size="sm"
                :placeholder="service.assembly_type"
                disabled
              />
              <b-btn
                v-if="getUserBrandPermissions.super_admin
                  && service.status == 'created'"
                size="sm"
                @click="assemblyModal.show = true"
              >
                <v-icon name="wrench"></v-icon>
              </b-btn>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 style="margin-top: 4px" class="text-info">
              {{ $t("globals.billed") }}:
            </h6>
          </b-col>
          <b-col>
            <b-form-input
              :placeholder="
                service.billed ? $t('globals.yes') : $t('globals.no')
              "
              size="sm"
              disabled
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 style="margin-top: 4px" class="text-info">
              {{ $t("globals.to_be_billed") }}:
            </h6>
          </b-col>
          <b-col>
            <b-form-input
              :placeholder="
                service.needs_to_be_billed
                  ? $t('globals.yes')
                  : $t('globals.no')
              "
              size="sm"
              disabled
            />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <ulu-assembly-modal 
      :show="assemblyModal.show"
      :close="closeModals"
      :assembly_type="service.assembly_type"
    />
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    "ulu-assembly-modal": () =>
      import("@/components/services/service/ServiceAssemblyModal")
  },
  data() {
    return {
      assemblyModal: {
        show: false
      }
    }
  },
  props: {
    refresh: Function,
    service: {
      type: Object,
      default: () => ({
        status: "",
        assembly_type: "",
        service_type: "",
        agent: { full_name: "" },
        created_at: "",
        order: { id: 0 },
        customer: { id: 0 },
        billed: false
      })
    }
  },
  methods: {
    closeModals() {
      this.assemblyModal.show = false;

      this.refresh();
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
};
</script>
